import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocalizeRouterService } from '../services/localize-router-service';

@Pipe({
    name: 'localize',
})
export class LocalizePipe implements PipeTransform {
    private localizeRouterService = inject(LocalizeRouterService);

    transform(url: string | string[] | null): string[] {
        return this.localizeRouterService.translateRoute(url);
    }
}
